const state = {
  selectedTags: [],
  inEdit: null
}

const getters = {
  selected: state => state.selectedTags || [],
  inEdit: state => state.inEdit || {}
}

const mutations = {
  setSelected(state, tags) {
    state.selectedTags = tags
  },
  setEdit(state, tag) {
    state.inEdit = tag
  }
}

const actions = {
  setSelectedTags({commit}, payload) {
    commit('setSelected', payload)
  },
  setEditTag({commit}, payload) {
    commit('setEdit', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
